export default __webpack_public_path__ + "static/media/team_paul.e6f6aca8.png";